// extracted by mini-css-extract-plugin
export default {"content":"App_content__2v+tG","startscreen":"App_startscreen__QQNnV","version":"App_version__4u4gG"};